export default {
  label: {
    id: 'product_page_new_battery_label',
    defaultMessage: 'Add a brand new battery',
  },
  link: {
    id: 'product_page_new_battery_link',
    defaultMessage: 'See if you need it',
  },
  disabled: {
    id: 'product_page_new_battery_disabled',
    defaultMessage: 'New battery - Sold out ',
  },
}
